import AuthContext from "./AuthContext";
export default AuthContext.Provider;
